// ================================================================================
// Custom events
//
// To help make it easier to add custom functionality, the theme emits custom
// events (along with their associated data) related to key theme features.
//
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.
// ================================================================================

/* eslint-disable no-console */

// ================================================================================
// "Item added to the cart"
//
// - Fires whenever an item has been added to the cart
// - Exposed when the ajax cart is enabled
// - "detail" object data:
//   - The associated product object
// ================================================================================
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// ================================================================================
// "Cart updated"
//
// - Fires whenever the cart is updated
// - Exposed when the ajax cart is enabled
// - "detail" object data:
//   - The cart object
// ================================================================================
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
  UpdateGiftUI(evt.detail.cart);
  setTimeout(() => {
    window.giftWithPurchase(evt.detail.cart);
    window.addBogoProduct(evt.detail.cart);
  }, 500);
});

function UpdateGiftUI(cart) {
  const cartTotal = cart.total_price / 100;
  const freeProductThreshold = parseFloat(document.querySelector('.js-data-free-product-threshold')?.getAttribute('data-free-product-threshold')) || 0;

  if (cartTotal < freeProductThreshold) {
      document.querySelectorAll(".js-gift-cart-button").forEach(item => {
      item.classList.add('visually-hidden');
    });
    document.querySelector(".quick-cart__container")?.classList.remove('gift-drawer-open');
    document.querySelector(".quick-cart__wrapper")?.classList.remove('gift-drawer-open');
  } else {
    document.querySelectorAll(".js-gift-cart-button").forEach(item => {
     item.classList.remove('visually-hidden');
    });
  }

  if (Array.isArray(cart.items_removed) && cart.items_removed.length > 0) {
    const cartRemoveId = cart.items_removed[0]?.variant_id;

    if (cartRemoveId) {
      const removeButton = document.querySelector(`.js-remove-product[data-gift-remove-id="${cartRemoveId}"]`);
      if (removeButton) {
        const container = removeButton.closest('.main-add-to-cart');
        const addButton = container?.querySelector('.js-gift-add-to-cart');
        const addWrapper = container?.querySelector('.product-add'); 
        
        if (addButton) addButton.closest(".product-item").classList.remove('active');
        if (addButton) addButton.classList.remove('visually-hidden');
        if (addWrapper) addWrapper.classList.add('visually-hidden');
      }
    }
  }
}





// ================================================================================
// "Cart error"
//
// - Fires whenever there is an error when adding an item to the cart
//   - Typically due to a product not having sufficient stock
// - "detail" object data:
//   - The error message
// ================================================================================
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// ================================================================================
// "Quick cart opened"
//
// - Fires whenever the quick cart is opened
// - Exposed when the ajax cart is enabled
// - "detail" object data:
//   - The cart object
// ================================================================================
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// ================================================================================
// "Quick cart closed"
//
// - Fires whenever the quick cart is opened
// - Exposed when the ajax cart is enabled
// ================================================================================
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// ================================================================================
// "Product variant changed"
//
// - Fires whenever a variant product is selected
// - Exposed when a 'Variant selectors' block has been added to a product template
//   or featured product section
// - "detail" object data:
//   - The variant object
// ================================================================================
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
  imagesChange(evt.detail.variant.title); 
  mobileImageChanges(evt.detail.variant.title);
  variantsDescriptionChanges(evt.detail.variant.id);
  notifyButtonDisplay(evt.detail.variant);
});

// Varints  Changes image change start
{

  window.addEventListener("load", function () {
    let variantTitle = document.querySelector(".product__inner")?.getAttribute("data-initial-variant-id");
    if (variantTitle == "Default Title") {
      return
    }
    if (variantTitle) {
      imagesChange(variantTitle);
      mobileImageChanges(variantTitle);
    } else {
      console.log(".product__inner element not found or data-initial-variant-id not available.");
    }
  });

  function imagesChange(variantTitle) {
    if (!window.matchMedia("(min-width: 767px)").matches || !variantTitle) return;
    const productTitle = document.querySelector(".product__block--product-header-inner .product__title")?.textContent?.trim();
    const thumbnailContainer = document.querySelector(".js-media-container");
    if (!thumbnailContainer) return;

    const images = thumbnailContainer.querySelectorAll("img");
    let firstMatchClicked = false;
    let matchingImageFound = false;

    images.forEach(img => {
      const parentThumbnail = img.closest(".product-thumbnails__item");
      const parentMediaItem = img.closest(".product__media-item");
      const lightboxImage = parentMediaItem ? parentMediaItem.querySelector("a") : null;
      const imgAlt = img.alt?.trim();
      const isAlwaysVisible = !imgAlt || imgAlt === productTitle;

      // Images with no alt should always be shown

      if (imgAlt === variantTitle || isAlwaysVisible) {
        img.classList.remove("hideMediumUp");
        if (lightboxImage) lightboxImage.classList.add("lightbox-image");
        if (parentThumbnail) parentThumbnail.style.display = '';
        if (parentMediaItem) parentMediaItem.style.display = '';
        
        if (!firstMatchClicked && imgAlt === variantTitle && parentThumbnail) {
          const firstButton = parentThumbnail.querySelector("button");
          if (firstButton) {
            firstButton.click();
            console.log("Clicked first button in thumbnail:", firstButton);
            firstMatchClicked = true;
            matchingImageFound = true;
          }
        }
      } else {
        img.classList.add("hideMediumUp");
        if (lightboxImage) lightboxImage.classList.remove("lightbox-image");
        if (parentThumbnail) parentThumbnail.style.display = 'none';
        if (parentMediaItem) parentMediaItem.style.display = 'none';
      }
    });

    if (!matchingImageFound) {
      console.log("No matching image found, resetting all images.");
      images.forEach(img => {
        img.classList.remove("hideMediumUp");
         const lightboxImage = parentMediaItem ? parentMediaItem.querySelector("a") : null;
         if (lightboxImage) lightboxImage.classList.add("lightbox-image");
        const parentThumbnail = img.closest(".product-thumbnails__item");
        const parentMediaItem = img.closest(".product__media-item");
        if (parentThumbnail) parentThumbnail.style.display = '';
        if (parentMediaItem) parentMediaItem.style.display = '';
      });
    }
  }

  function mobileImageChanges(variantTitle) {
    if (!window.matchMedia("(max-width: 767px)").matches || !variantTitle) return;

    const productTitle = document.querySelector(".product__block--product-header-inner .product__title")?.textContent?.trim();
    const mediaContainerMobile = document.querySelector(".js-media-container-mobile .scroll-slider__slider");
    const mediaThumbContainerMobile = document.querySelector(".js-media-container-mobile .product-thumbnails__items");
    if (!mediaContainerMobile) return;

    const slides = mediaContainerMobile.querySelectorAll(".product__media-item");
    const thumbnails = mediaThumbContainerMobile.querySelectorAll(".product-thumbnails__item");

    Array.from(slides).concat(Array.from(thumbnails)).forEach(element => {
     element.classList.add('product__media-item--hidden');
    });
    
    Array.from(slides).filter(element => {
      let imgAlt = element.dataset.mediaAlt;
      return (imgAlt == variantTitle || imgAlt == productTitle);
    }).forEach((element,index) => {
      element.classList.remove('product__media-item--hidden');
      element.setAttribute('data-slide-index',index);
    });

    let thumbImages = Array.from(thumbnails).filter(element => {
      let imgAlt = element.dataset.mediaAlt;
      return (imgAlt == variantTitle || imgAlt == productTitle);
    });
    thumbImages.forEach((element,index) => {
      element.classList.remove('product__media-item--hidden');
      element.querySelector('[data-product-thumbnail]').setAttribute('data-thumbnail-index',index);
    });

    thumbImages.filter(element => element.dataset.mediaAlt == variantTitle)[0].querySelector('[data-product-thumbnail]').click();

    const scrollSlider = document.querySelector(".js-media-container-mobile scroll-slider-component");
    if (scrollSlider && typeof scrollSlider.initScroller === "function") {
      scrollSlider.fetchSlides();
      scrollSlider.initScroller();
    }
  }

}
// variant description chnage
{
  function variantsDescriptionChanges(variantId) {
    const jsonEl = document.querySelector('.variants-description');
    if (!jsonEl) return;

    let variantData;
    try {
      variantData = JSON.parse(jsonEl.textContent);
    } catch (e) {
      console.error('Failed to parse variant descriptions JSON', e);
      return;
    }

    const newHtml = variantData[variantId];
    if (!newHtml) {
      console.warn('No description found for variant:', variantId);
      return;
    }

    const contentContainer = document.querySelector('.js-content');
    if (!contentContainer) {
      console.warn('Target content container (.js-content) not found.');
      return;
    }
    contentContainer.outerHTML = newHtml;
  }
}


{
function notifyButtonDisplay(variant) {
  const buttonLink = document.querySelector('.js-klaviyo-btn');
  const addToCartEl = document.querySelector(".ins-custom-add-to-cart-c12") ||  document.querySelector(".ins-custom-add-to-cart-c14")

  if (!addToCartEl) return;

  if (!variant.available) {

    const cartSubmit = buttonLink?.closest('.product-form__item')?.querySelector('.product-form__cart-submit');
    cartSubmit?.classList.add('visually-hidden');

    if (buttonLink) {
      buttonLink.classList.remove('visually-hidden');
      buttonLink.style.display = 'block';
    }

    addToCartEl.classList.add("sticky-add-hidden");

    if (!addToCartEl.nextElementSibling?.classList.contains("klaviyo-bis-trigger")) {
      const notifyBtn = document.createElement("button");
      notifyBtn.className = "klaviyo-bis-trigger btn btn--medium btn--full btn--secondary js-klaviyo-btn";
      notifyBtn.innerText = "Notify Me When Available";
      addToCartEl.parentNode.insertBefore(notifyBtn, addToCartEl.nextSibling);
    }

  } else {
    const cartSubmit = buttonLink?.closest('.product-form__item')?.querySelector('.product-form__cart-submit');
    cartSubmit?.classList.remove('visually-hidden');

    if (buttonLink) {
      buttonLink.classList.add('visually-hidden');
      buttonLink.style.display = 'none';
    }

    addToCartEl.classList.remove("sticky-add-hidden");

    const stickyNotifyBtn = addToCartEl.nextElementSibling;
    if (stickyNotifyBtn?.classList.contains("klaviyo-bis-trigger")) {
      stickyNotifyBtn.remove();
    }
  }
}

  const interval = setInterval(() => {
    const productInner = document.querySelector(".product__inner");
    const addToCartEl = document.querySelector(".ins-custom-add-to-cart-c12") ||  document.querySelector(".ins-custom-add-to-cart-c14")

    if (productInner && addToCartEl) {
      clearInterval(interval); // Stop the interval once elements are found

      const variantAvailable = productInner.getAttribute("data-variant-available");

      if (variantAvailable === "false") {
        addToCartEl.classList.add("sticky-add-hidden");

        // Prevent duplicate notify button
        if (!addToCartEl.nextElementSibling?.classList.contains("klaviyo-bis-trigger")) {
          const notifyBtn = document.createElement("button");
          notifyBtn.className = "klaviyo-bis-trigger btn btn--medium btn--full btn--secondary js-klaviyo-btn";
          notifyBtn.innerText = "Notify Me When Available";

          addToCartEl.parentNode.insertBefore(notifyBtn, addToCartEl.nextSibling);
        }
      }
    }
  }, 300);
}



// ================================================================================
// "Product quantity updated"
//
// - Fires whenever a product quanatiy is updated
// - Exposed when a 'Quantity selector' block has been added to a product template
//   or featured product section
// - "detail" object data:
//   - The variant object
//   - The quantity
// ================================================================================
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// ================================================================================
// "Quick view loaded"
//
// - Fires whenever a quick view modal is opened
// - Exposed when the 'Enable quick view' setting is enabled and a quick view
//   modal is opened
// ================================================================================
document.addEventListener("quick-view:loaded", function () {
  console.log("Quick view loaded");
});
/* eslint-enable no-console */

/**
 * Grid alignment Script
 */
{
  window.setGridHeight = (selector) => {
    let gridOffsets = [];
    let gridRowOffsets = []

    gridOffsets = Array.from(document.querySelectorAll(selector)).map((element,index) => {
      let grid = element.closest('.grid__item') || element.closest('[data-equal]');
      element.removeAttribute('style');
      return {
        selector:element,
        selectorHeight: element.offsetHeight,
        offsetTop: grid?.offsetTop || 0,
      }
    });

    let offsets = gridOffsets.map(element => element.offsetTop);
    gridRowOffsets = [...new Set(offsets)];

    gridRowOffsets.forEach(rowOffset => {
      let rowGrids = gridOffsets.filter(grid => (grid.offsetTop == rowOffset));
      let comanElementHeight = Math.max.apply(Math,(rowGrids.map(ele => ele.selectorHeight)));
      rowGrids.forEach(grid => {
        grid.selector.style.minHeight = comanElementHeight+'px';
      });
    });
  }

 setTimeout(() => {
    matchHeightCallback();
  }, 2000)
  
  window.addEventListener('resize', function(event){
    matchHeightCallback();
  });

  let matchHeightCallback = () => {
    // window.setGridHeight('.product-card-wrapper .card__heading'); 
  }
  matchHeightCallback();
}


window.redirectUrl  = async function () {
  try {
    const response = await fetch(
      `${window.Shopify.routes.root}browsing_context_suggestions.json?country[enabled]=true&country[exclude]=${window.Shopify.country}&language[enabled]=true&language[exclude]=${window.Shopify.language}`
    );
    const data = await response.json();

    if (data?.detected_values?.country) {
      const countryName = data.detected_values.country.name;
      const countryHandle = data.detected_values.country.handle;

      // Redirect if NOT Mexico or US
      // if (!(countryName === "Mexico" || countryHandle === "MX" || countryName === "United States" || countryHandle === "US")) {
      if (!( countryName === "United States" || countryHandle === "US")) {
        console.log("Redirecting to mcobeauty.com");
        location.href = "https://mcobeauty.com/";
        return;
      }

      // Disable "Add to Cart" button for Mexico users
      // if (countryName === "Mexico" || countryHandle === "MX") {
      //   document.querySelectorAll(".product-form__cart-submit").forEach((button) => {
      //     button.setAttribute("disabled", "true");
      //   });
      // }

      console.log("Country Name:", countryName);
      console.log("Country Handle:", countryHandle);
    }
  } catch (error) {
    console.error("Error fetching country data:", error);
  }
};
if (!Shopify.designMode) {
  window.redirectUrl();
}
